"use client";

import { setCookie, getCookie, deleteCookie } from "@/lib/cookieUtils";

const GUEST_TOKEN_KEY = "artha_guest_token";

export const guestAuthService = {
  getToken: (): string | null => {
    if (typeof window === "undefined") return null;
    return localStorage.getItem(GUEST_TOKEN_KEY) || getCookie(GUEST_TOKEN_KEY);
  },

  setToken: (token: string): void => {
    if (typeof window === "undefined") return;
    localStorage.setItem(GUEST_TOKEN_KEY, token);
    setCookie(GUEST_TOKEN_KEY, token, 24 * 60 * 60);
  },

  clearToken: (): void => {
    if (typeof window === "undefined") return;
    localStorage.removeItem(GUEST_TOKEN_KEY);
    deleteCookie(GUEST_TOKEN_KEY);
  },

  isGuest: (): boolean => {
    return !!guestAuthService.getToken();
  },
};
